var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('carousel'),_c('notice'),_c('news'),_c('welfare-project'),_c('classic-case'),_c('multi-media'),_c('support'),_c('friendly-link'),_c('sidebar'),_vm._l((_vm.list),function(item,idx){return _c('div',{key:idx},[_c('FloatingWindow',{attrs:{"item":item,"width":400}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }